const HOSPITALS_DICTIONARY_ID = "hospitals";
const GROUPS_DICTIONARY_ID = "groups";
const LOGINS_DICTIONARY_ID = "logins";
const SUBSCRIPTION_DICTIONARY_ID = "subscriptions";

export { HOSPITALS_DICTIONARY_ID, GROUPS_DICTIONARY_ID, LOGINS_DICTIONARY_ID, SUBSCRIPTION_DICTIONARY_ID };
